var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-xl":"","align-content-start":""}},[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('v-flex',[_c('formAdminOnboardingAcctDatatable',{attrs:{"type":'view'}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }